/** Chuỗi của "Khoản chi và tiền lời" (KH-GĐ2 5.3). Tiếng Việt có dấu, câu ngắn. */
import type { NhomChiCoSan } from '@sapa/shared'
import { chuHienTai } from './theo-nganh.ts'

export const NHOM_CHI_TEN: Record<NhomChiCoSan, string> = {
  'vat-tu': 'Hoá chất, vật tư',
  'mat-bang': 'Mặt bằng',
  'dien-nuoc': 'Điện nước',
  'luong-hoa-hong': 'Lương, hoa hồng',
  'ung-luong': 'Ứng lương',
  khac: 'Khác',
}

export const C = {
  tab: 'Chi tiêu',
  // Tiền lời tháng (chỉ người xem được doanh thu)
  loiThang: (thang: string) => `Tiền lời tháng ${thang}`,
  lo: (thang: string) => `Tháng ${thang} lỗ`,
  thuTruChi: (thu: string, traLai: string | null, chi: string) =>
    traLai === null
      ? `Thu ${thu} − chi ${chi}`
      : `Thu ${thu} − trả lại khách ${traLai} − chi ${chi}`,
  traTruoc: (tien: string) => `Trong đó ${tien} là tiền khách trả trước (gói, ví).`,
  giaiThich: 'Tính theo tiền thật vào và ra trong tháng. Tiền bo của thợ không tính.',
  thangTruoc: 'Tháng trước',
  thangSau: 'Tháng sau',
  nhanThang: (thang: string) => `Tháng ${thang}`,
  // Ghi khoản chi
  ghi: 'Ghi khoản chi',
  soTien: 'Chi bao nhiêu',
  nhom: 'Chi cho việc gì',
  themNhom: 'Thêm nhóm',
  tenNhomMoi: 'Tên nhóm mới',
  tenNhomGoiY: 'ví dụ: Quảng cáo',
  luuNhom: 'Thêm',
  cach: 'Trả bằng',
  tienMat: 'Tiền mặt (lấy từ két)',
  chuyenKhoan: 'Chuyển khoản',
  chiNhanh: 'Két chi nhánh',
  chiNhanhCk: 'Chi nhánh',
  ghiChu: 'Ghi chú (không bắt buộc)',
  get ghiChuGoiY() {
    return chuHienTai().viDuKhoanChi
  },
  ungChoAi: 'Ứng cho ai (bắt buộc)',
  ungGoiY: 'ví dụ: chị Hoa ứng lương tháng 10',
  quaTranQuay: 'Chi tiền mặt trên 2.000.000đ nhờ chủ tiệm hoặc quản lý ghi.',
  luu: 'Lưu khoản chi',
  daGhi: (tien: string) => `Đã ghi khoản chi ${tien}.`,
  // Danh sách
  dsTitle: 'Các khoản chi trong tháng',
  chuaCo: 'Tháng này chưa ghi khoản chi nào.',
  dongNguoi: (ten: string | null) => (ten === null ? '' : ` · ${ten}`),
  daBo: 'Đã bỏ',
  boKhoan: 'Ghi nhầm',
  boHoi: (ten: string, tien: string, tienMat: boolean) =>
    `Bỏ khoản ${ten} ${tien}?${tienMat ? ' Két cộng lại số này.' : ''}`,
  boLyDoGoiY: 'ví dụ: ghi nhầm số tiền',
  dongBo: (ngay: string | null) =>
    ngay === null ? 'Bỏ khoản ghi nhầm' : `Bỏ khoản ghi nhầm ngày ${ngay}`,
  tienMatNgan: 'Tiền mặt',
  chanNghin: 'Số tiền chẵn nghìn, ví dụ 45.000đ.',
  chonNhom: 'Chạm một nhóm để lưu.',
  boLyDo: 'Ghi nhầm',
  boNut: 'Bỏ khoản này',
  thoi: 'Thôi',
  daBoXong: 'Đã bỏ khoản chi ghi nhầm.',
  // Hoa hồng tháng (thẻ Bảng hoa hồng)
  hoaHong: (thang: string) => `Ghi đã trả hoa hồng tháng ${thang}`,
  hoaHongSo: 'Số đã trả thợ (trừ phần đã ứng nếu có)',
  hoaHongDaCo: (tien: string) => `Đã ghi khoản chi hoa hồng tháng này: ${tien}.`,
  hoaHongGiaiThich: 'Ghi tổng bảng hoa hồng đã chốt thành một khoản chi. Mỗi tháng ghi một lần.',
  hoaHongDaGhi: (tien: string) => `Đã ghi khoản chi hoa hồng ${tien}.`,
} as const
